<template>
  <div class="rule-page">
    <div class="rule-shell">
      <header class="rule-head">
        <button type="button" class="head-btn" :aria-label="$t('auth.back')" @click="back">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M15 18l-6-6 6-6"></path>
          </svg>
        </button>
        <div class="head-copy">
          <h1>{{ pageTitle }}</h1>
        </div>
        <button type="button" class="head-btn" :aria-label="$t('auth.home')" @click="goHome">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 11l9-8 9 8"></path>
            <path d="M5 10v10h14V10"></path>
          </svg>
        </button>
      </header>

      <main class="rule-content">
        <article v-if="contentHtml" class="rule-card" v-html="contentHtml"></article>
        <div v-else class="rule-empty">{{ copy.empty }}</div>
      </main>
    </div>
  </div>
</template>

<script>
import { getPageCopy } from "@/common/pageLocale";

export default {
  data() {
    return {
      title: "",
      contentHtml: "",
    };
  },
  computed: {
    copy() {
      return getPageCopy(this, "platformRule");
    },
    pageTitle() {
      return this.title || this.copy.title || "平台规则";
    },
  },
  created() {
    this.fetchRule();
  },
  mounted() {
    document.title = `${this.pageTitle} · OMN`;
  },
  methods: {
    async fetchRule() {
      try {
        const res = await this.$http({
          method: "get",
          url: "platform_rule",
        });
        if (res && res.code === 200 && res.data) {
          this.title = res.data.title || "";
          this.contentHtml = res.data.content || "";
          document.title = `${this.pageTitle} · OMN`;
          return;
        }
        this.contentHtml = "";
      } catch (error) {
        this.contentHtml = "";
      }
    },
    back() {
      window.history.back();
    },
    goHome() {
      this.$router.push("/Home");
    },
  },
};
</script>

<style lang="less" scoped>
.rule-page {
  min-height: 100vh;
  min-height: 100dvh;
  background:
    radial-gradient(circle at 100% 0, rgba(255, 63, 120, 0.11), transparent 28%),
    #0a0710;
  color: #fff7fb;
}

.rule-shell {
  width: 100%;
  max-width: 25rem;
  margin: 0 auto;
}

.rule-head {
  position: sticky;
  top: 0;
  z-index: 20;
  display: grid;
  grid-template-columns: 2.625rem 1fr 2.625rem;
  align-items: center;
  min-height: 4.1875rem;
  padding: max(0.5rem, env(safe-area-inset-top)) 0.8125rem 0.5rem;
  background: rgba(10, 7, 16, 0.92);
  border-bottom: 1px solid rgba(255, 255, 255, 0.085);
}

.head-btn {
  width: 2.375rem;
  height: 2.375rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.085);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.045);
  color: #fff;
  cursor: pointer;
}

.head-btn svg {
  width: 1.1875rem;
  height: 1.1875rem;
}

.head-copy h1 {
  margin: 0;
  text-align: center;
  font-size: 1.125rem;
  font-weight: 900;
}

.rule-content {
  padding: 1rem;
}

.rule-card {
  padding: 1rem;
  border-radius: 1.2rem;
  border: 1px solid rgba(255, 255, 255, 0.085);
  background: rgba(255, 255, 255, 0.045);
  color: #f3e8f0;
  font-size: 0.88rem;
  line-height: 1.7;
  word-break: break-word;
}

.rule-card ::v-deep img {
  max-width: 100%;
  height: auto;
}

.rule-empty {
  padding: 2rem 1rem;
  text-align: center;
  color: #a89baa;
  font-size: 0.88rem;
}
</style>
